import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import { EMPTY_CUPO } from '../../actions/constants'
import { reduxForm } from 'redux-form'
import { FORM_CUPO } from '../../../../config/forms'
import { EditAsignacionDialogView } from '../../components/asignacionCupos/EditAsignacionDialogView'
import DialogView from '../../../Dialogos/DialogView'

class EditAsignacionDialog extends Component {
  render () {
    const { confirmCallback, cancelCallback } = this.props

    return (
      <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Modificar cantidad de cupos asignados'
        content={<EditAsignacionDialogView
          currentCupo={this.props.currentCupo}
        />}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    // currentCupo: selector(state, currentCupo)
  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_CUPO,
  initialValues: EMPTY_CUPO,
  enableReinitialize: true
})(EditAsignacionDialog))
